<template>
    <div class="formreq-analysis grid full-width">

      <div class="date-range grid-child box-rounded">
        <div class="option-field left-float col-3">
          <select id="range-options" v-model="selectedOption" @change="handleOptionChange" class="full-width">
            <option value="today">Hoje</option>
            <option value="last7days">Últimos 7 dias</option>
            <option value="thisMonth">Este mês</option>
            <option value="lastMonth">Mês passado</option>
            <option value="custom">Personalizado</option>
          </select>
          
          <div v-if="selectedOption === 'custom'" class="date-inputs">
            <div class="option-field">
              <label for="start-date">Data de Início:</label>
              <input type="date" id="start-date" v-model="startDate" @change="updateCustomRange">
            </div>
            
            <div class="option-field">
              <label for="end-date">Data de Fim:</label>
              <input type="date" id="end-date" v-model="endDate" @change="updateCustomRange" :min="startDate">
            </div>
          </div>
        </div>
        <button class="apply-button col-1 mt-10" @click="submit">Buscar</button>
      </div>

      <div class="grid-child box-rounded">
            <div class="aggregation-controls">
                <span class="label">Agrupamento:</span>
                {{ aggregationMode }}
                <button class="mode-button" :class="{ active: aggregationMode === 'time' }" @click="setAggregationMode('time')">Tempo</button>
                <button class="mode-button" :class="{ active: aggregationMode === 'significant' }" @click="setAggregationMode('significant')">Significativo</button>
            </div>

            <div class="aggregation-options">
                <div class="option-field">
                <label for="agg-interval">Intervalo (horas)</label>
                <input id="agg-interval" v-model.number="intervalHours" type="number" min="0.1" step="0.1"/>
                </div>
                <div class="option-field">
                <label for="agg-qty">Delta Qty</label>
                <input id="agg-qty" v-model.number="qtyDelta" type="number" min="0" step="0.0001"/>
                </div>
                <div class="option-field">  
                <label for="agg-pmp">Delta PMP (%)</label>
                <input id="agg-pmp" v-model.number="pmpDeltaPct" type="number" min="0" step="0.001" />
                </div>
                <div class="option-field">
                <label for="agg-price">Delta Preco</label>
                <input id="agg-price" v-model.number="priceDelta" type="number" min="0" step="1"/>
                </div>
                <button class="apply-button" @click="applyAggregationOptions">Aplicar</button>
            </div>
      </div>

    </div>
</template>

<script>
import { DEFAULT_AGG_OPTIONS } from '@/utils/aggregateLogs';
import { formatDateOnInputsForm } from '@/utils/funcs';

export default {
  name: 'portfolioReq',
  props: {
    initialAggregationMode: { type: String, default: 'time' },
    initialAggregationOptions: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      aggregationMode: this.initialAggregationMode,
      selectedOption: 'thisMonth', //opcao padrao
      startDate: '',
      endDate: '',
      intervalHours: 24,
      qtyDelta: DEFAULT_AGG_OPTIONS.qtyDelta,
      pmpDeltaPct: DEFAULT_AGG_OPTIONS.pmpDeltaPct,
      priceDelta: DEFAULT_AGG_OPTIONS.priceDelta,
    };
  },
  methods: {
    handleOptionChange() {
      const today = new Date();

      if (this.selectedOption === 'today') {
          this.startDate = formatDateOnInputsForm(today);
          this.endDate = formatDateOnInputsForm(today);
          this.intervalHours = 1
      } 

      else if (this.selectedOption === 'last7days') {
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 6); // 6 dias antes (7 dias no total)
        this.startDate = formatDateOnInputsForm(last7Days);
        this.endDate = formatDateOnInputsForm(today);
        this.intervalHours = 24
      }

      else if (this.selectedOption === 'thisMonth') {
        const firstDayThisMonth = new Date(today.getFullYear(), today.getMonth(), 1); // Primeiro dia do mês atual
        this.startDate = formatDateOnInputsForm(firstDayThisMonth);
        this.endDate = formatDateOnInputsForm(today);
        this.intervalHours = 24
      }

      else if (this.selectedOption === 'lastMonth') {
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        this.startDate = formatDateOnInputsForm(firstDayLastMonth);
        this.endDate = formatDateOnInputsForm(lastDayLastMonth);
        this.intervalHours = 24
      } 
    },

    updateCustomRange() { // Garantir que o intervalo personalizado esteja válido
      if (this.endDate && this.startDate > this.endDate) {
        this.endDate = this.startDate;
      }
    },
    setAggregationMode(mode) {
      this.aggregationMode = mode;
      this.$emit('aggregationChange', {
        aggregationMode: this.aggregationMode,
        aggregationOptions: this.buildAggOptions()
      });
    },
    buildAggOptions() {
      return {
        intervalMs: Math.max(this.intervalHours, 0.1) * 60 * 60 * 1000,
        qtyDelta: Math.max(this.qtyDelta, 0),
        pmpDeltaPct: Math.max(this.pmpDeltaPct, 0),
        priceDelta: Math.max(this.priceDelta, 0),
      };
    },
    applyAggregationOptions() {
      this.$emit('aggregationChange', {
        aggregationMode: this.aggregationMode,
        aggregationOptions: this.buildAggOptions()
      });
    },
    submit() {

      this.handleOptionChange()

      if (!this.startDate || !this.endDate) return;
      if (this.endDate < this.startDate) return;

      this.$emit('request', {
        startDate: this.startDate,
        endDate: this.endDate,
        aggregationMode: this.aggregationMode,
        aggregationOptions: this.buildAggOptions()
      });
    },
    formatDateOnInputsForm,
  }
};
</script>

<style scoped>

.formreq-analysis {
  grid-template-columns: 0.4fr 1fr;
}

.aggregation-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 16px;
}

.label {
  font-weight: 600;
  opacity: 0.85;
}

.mode-button {
  border: 1px solid #3b3b3b;
  background: #1f1f1f;
  color: #e2e2e2;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.mode-button:hover {
  border-color: #5a5a5a;
}

.mode-button.active {
  border-color: #2aa5a1;
  background: #153b3a;
  color: #d8f3f2;
}

.aggregation-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin: 0 0 16px;
  align-items: end;
}

.option-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.option-field label {
  font-size: 12px;
  opacity: 0.85;
}

.option-field input, .option-field select {
  border: 1px solid #3b3b3b;
  background: #151515;
  color: #e2e2e2;
  padding: 6px 8px;
  border-radius: 6px;
}

.apply-button {
  border: 1px solid #2aa5a1;
  background: #153b3a;
  color: #d8f3f2;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.apply-button:hover {
  border-color: #39c2bd;
  background: #1f4f4e;
}

.chart-portfolio {
  height: 500px;
  margin-bottom: 24px;
}
</style>
